import { type Pair } from 'shur-api'
import { fallbackNoDetailsAvailableDataSection } from './SHUREmptyDataCreator'
import type { DataBlock, SingleBlock } from 'de-zurich-ui-library'
import { t } from '@/i18n'
import { coverageConceptIconData } from './SHURDataboxData'
import { ProductSubType } from 'shur-api'

/**
 * Validates details and returns them if valid, null otherwise
 */
export function validateDetails(details?: Pair[]): Pair[] | null {
  if (!details || details.length === 0) return null
  return details
}

/**
 * Helper to find value by key in details array
 */
export function findValueByKey(details: Pair[], key: string): string | null {
  return details.find((entry) => entry.key === key)?.value ?? null
}

/**
 * Creates a data field with label and value lookup
 */
export function createDataField(
  labelKey: string,
  details: Pair[],
  valueKey: string
): SingleBlock {
  return {
    label: t(labelKey),
    value: findValueByKey(details, valueKey)
  }
}

/**
 * Creates a data block with validation and title
 */
export function createDataBlock(
  titleKey: string,
  details: Pair[] | null,
  dataFields: SingleBlock[]
): DataBlock {
  if (!details) return fallbackNoDetailsAvailableDataSection()

  return <DataBlock>{
    title: { label: t(titleKey) },
    data: dataFields
  }
}

/**
 * Creates coverage concept field with icon (shared across creators)
 */
export function createCoverageConceptField(
  details: Pair[],
  productSubType: ProductSubType
): SingleBlock {
  const coverageConcept = findValueByKey(details, 'COVERAGE_CONCEPT')
  const productVersion = findValueByKey(details, 'PRODUCT_VERSION') || ''

  return {
    label: t('shurDetails.sections.coverageConcept.title'),
    value: coverageConcept
      ? t(`shurDetails.sections.coverageConcept.${coverageConcept}`)
      : null,
    iconSpan: coverageConcept
      ? coverageConceptIconData(coverageConcept, productSubType, productVersion)
      : undefined
  }
}
